import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import commonReducer from 'Slices/commonSlices/Common_slice'
import AuthReducer from 'views/common/Slice/AuthSlice';
import milleSearchReducer from 'Slices/commonSlices/milleSearchFilter'
import superAdminJobsReducer from 'Slices/SuperAdmin/Jobs'
import chatbotReducer from 'Slices/commonSlices/Chatbot_slice'

const reducers = combineReducers({
    authState: AuthReducer,
    commonState: commonReducer,
    milleSearchStates: milleSearchReducer,
    saJobsState: superAdminJobsReducer,
    chatBotState: chatbotReducer
})

export const store = configureStore({
    reducer: reducers,
    middleware: (getMiddleware) => getMiddleware({
        serializableCheck: false
    }).concat(thunk),
    devTools: window.location.hostname === "localhost"
})